import React from 'react';
import { message, Modal } from 'antd';
import EditableCell from '../../common/tableCell/TableCell';
import TableC from '../../basicElement/TableC';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import '../style/list.less';

class CrfTable extends React.Component {
	state = {
		dataSource: [],
		columns: [],
		count: 0,
		loading: false,
		tableColumns: [],
		requiredMap: new Map(),
		moduleDefineCode: null,
		moduleDefineId: null,
	}

	getSaveParam = (rowDataOriginal) => {
		const rowData = JSON.parse(JSON.stringify(rowDataOriginal));
		const paramsObj = {
			newParams: '',
			postObj: {}
		};
		let indicatorCount = -1;
		const indicatorRowCount = {};
		const rowIndexObj = {};
		let newParams = ``;
		newParams += `?`;
		const saveRowNum = rowData.rowNum;
		for (const key in rowData) {
			if (typeof (rowData[key]) === "object") {
				if (key === (rowData[key].moduleDefineCode + '_' + rowData[key].rowNum)) {
					const { rowNum, moduleDefineCode } = rowData[key];
					const rowCount = indicatorRowCount[moduleDefineCode];
					const prevData = rowData[moduleDefineCode] ? (rowData[moduleDefineCode][rowNum * 1 - 1] || null) : null;
					if (!prevData && rowData[key].value) {
						rowData[key]["operationType"] = 'INSERT';
					} else if (prevData && prevData.value && !rowData[key].value) {
						rowData[key]["operationType"] = 'DELETE';
					} else if (prevData && prevData.value && rowData[key].value) {
						if (prevData.value != rowData[key].value) {
							rowData[key]["operationType"] = 'UPDATE';
						}
					}
					if (rowData[key].operationType) {
						if (rowCount >= 0) {
							indicatorRowCount[rowData[key].moduleDefineCode] = indicatorRowCount[rowData[key].moduleDefineCode] + 1;
						} else {
							indicatorRowCount[rowData[key].moduleDefineCode] = 0;
							indicatorCount++;
							rowIndexObj[rowData[key].moduleDefineCode] = indicatorCount;
						}
						for (const keySec in rowData[key]) {
							if (keySec == "rowNum") {
								paramsObj.postObj[`rowValues[${rowIndexObj[rowData[key].moduleDefineCode]}].indicators[${indicatorRowCount[rowData[key].moduleDefineCode]}].${keySec}`] = saveRowNum;
							} else {
								paramsObj.postObj[`rowValues[${rowIndexObj[rowData[key].moduleDefineCode]}].indicators[${indicatorRowCount[rowData[key].moduleDefineCode]}].${keySec}`] = rowData[key][keySec] ? rowData[key][keySec] : '';
							}
						}
						paramsObj.postObj[`rowValues[${rowIndexObj[rowData[key].moduleDefineCode]}].indicatorCode`] = rowData[key].moduleDefineCode;
					}
				}
			} else {
				newParams += '&' + key + '=' + rowData[key];
			}
		}
		paramsObj.newParams = newParams;
		return paramsObj;
	}

	rowSave = (record, index, flag) => {
		const { typeName, visitGroupingId } = this.props;
		const { requiredMap, dataSource } = this.state;
		for (let [key, value] of requiredMap) {
			if (record[key] == undefined || record[key] == "") {
				if (requiredMap.get(key) == "患者编号") {
					Modal.error({ title: `请输入您录入的${requiredMap.get(key)}` });
					return;
				} else {
					Modal.error({ title: `请输入${requiredMap.get(key)}` });
					return;
				}
			} else if (record[key]) {
				if (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter') {
					if (record[key].editable) {
						if (record[key]['value'] == "" || record[key]['value'] == undefined) {
							Modal.error({ title: `请输入${requiredMap.get(key)}` });
							return;
						}
					}
				}
			}
		}
		const paramsObj = this.getSaveParam(record);
		this.setState({ loading: true });
		const options = {
			url: `${API_URL.execute.save}${paramsObj.newParams}`,
			data: {
				...paramsObj.postObj,
				typeName,
				visitGroupingId,
				isCheck: flag !== '' ? 1 : flag,
				isHistory: (dataSource || []).length - 1 !== index ? 1 : '',
			},
			method: 'post',
			dataType: 'json',
			doneResult: (data => {
				if (!data.confirmError) {
					this.setState({
						loading: false
					}, () => {
                        this.props.loadData(true);
                    });
					message.success('保存成功');
					return;
				} else {
					Modal.confirm({
						iconType: 'exclamation-circle',
						title: <div style={{ marginLeft: 42 }}>该患者（访视）已被引用在工时记录中，删除此记录将同时影响对应工时的患者（访视）备注，是否确认删除?</div>,
						onOk: () => {
							this.rowSave(record, index, '');
						},
					});
				}
			}),
			errorResult: (data => {
				this.setState({ loading: false });
			}),
			failResult: (data => {
				this.setState({ loading: false });
			})
		};
		$.sendRequest(options);
	}

	showConfirm = (record, index) => {
		Modal.confirm({
			iconType: 'exclamation-circle',
			title: '确定要删除吗?',
			onOk: () => {
				this.queryData(record, index);
			},
		});
	}

	queryData = (record, index) => {
		const options = {
			url: `${API_URL.execute.deleteCrfRowDataCheck}`,
			data: { patientUserId: record.patientUserId },
			dataType: 'json',
			doneResult: (res => {
				if (res.data) {
					Modal.confirm({
						iconType: 'exclamation-circle',
						title: <div style={{ marginLeft: 42 }}>该患者（访视）已被引用在工时记录中，删除此记录将同时影响对应工时的患者（访视）备注，是否确认删除?</div>,
						onOk: () => {
							this.rowDelete(record, index);
						},
					});
				} else {
					this.rowDelete(record, index);
				}
			}),
		};
		$.sendRequest(options);
	}

	rowDelete = (record, index) => {
		const { visitGroupingId } = this.props;
		if (record.patientUserId == -1 || record.rowNum == undefined) {
			const { dataSource } = this.state;
			dataSource.splice(index, 1);
			this.setState({ dataSource }, () => {
				if (dataSource.length == 0) {
					const { tableColumns } = this.state;
					const { columns } = this.convertColumns(tableColumns);
					this.setState({ columns });
				}
			});
			message.success('删除成功');
			return;
		}
		const { typeName } = this.props;
		this.setState({ loading: true });

		const options = {
			url: `${API_URL.execute.deleteCrfRowData}`,
			data: {
				typeName,
				isAgain: 1,
				visitGroupingId,
				patientUserId: record.patientUserId,
				rowNum: record.rowNum
			},
			dataType: 'json',
			doneResult: (data => {
				this.setState({ loading: false }, () => {
					this.props.loadData(true);
				});
				message.success('删除成功');
			}),
			errorResult: (data => {
				this.setState({ loading: false });
			}),
			failResult: (data => {
				this.setState({ loading: false });
			})
		};
		$.sendRequest(options);
	}

	convertColumns = (tableColumns) => {
		const columns = [];
		const { dataSource } = this.state;
		const { typeName } = this.props;
		const dataEmpty = dataSource.length === 0 ? true : false;
		const requiredMap = new Map();
		const { curRole } = sessionStorage;
		const canEdit = (curRole == 'CRC' || curRole == 'PM' || curRole == 'PA') && (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter');
		
		const newTableColums = [];
		tableColumns.forEach(column => {
			const { rowNum, isShow, moduleDefineCode, moduleDefineName, moduleDefineIsRequired } = column;
			if (typeName == 'Type_Filter' || typeName == 'Type_Visit') {
				if (isShow) {
					newTableColums.push(column);
				}
			} else {
				newTableColums.push(column);
			}
			if (moduleDefineName !== '操作' || moduleDefineName !== '录入者') {
				if (moduleDefineIsRequired == "1") {
					requiredMap.set(moduleDefineCode + "_" + rowNum, moduleDefineName);
				} else if (moduleDefineIsRequired == "0" && (moduleDefineName == 'SAE结束时间' || moduleDefineName == '与试验药物是否相关' || moduleDefineName == 'SAE结局')) {
					requiredMap.set(moduleDefineCode + "_" + rowNum, moduleDefineName);
				}
			}
		});

		newTableColums.map((tableColumn, columnIndex) => {
			let title = tableColumn.moduleDefineName || '',
				type = tableColumn.criteriaDataType,
				webType = tableColumn.projectDefineWebType,
				dataIndex = tableColumn.moduleDefineCode == "op" ? tableColumn.moduleDefineCode : tableColumn.moduleDefineCode + "_" + tableColumn.rowNum,
				criteriaDefineId = tableColumn.criteriaDefineId,
				canAddComment = tableColumn.canAddComment,
				column = {
					visitTypeName: tableColumn.visitTypeName,
					visitTypeNameShow: tableColumn.visitTypeNameShow,
				},
				config = {
					isEdit: true,
					comment: {
						iscomment: false,
					},
					colorClass: "normal",
					type: {
						type: type,
						webType: webType,
						moduleDefineConstraintValue: tableColumn.moduleDefineConstraintValue,
						formatValue: tableColumn.formatValue
					},
					...tableColumn
				};
			
			column.width = 160;
			if (title == '录入者') {
				column.width = 80;
			}
			if (tableColumn.fixed == "left") {
				if (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter') {
					column.fixed = 'left';
				}
			}
			if (webType) {
				column.dataIndex = dataIndex;
			}
			column.type = type;
			column.webType = webType;
			if (tableColumn.canAddComment == 1) {
				config.comment.iscomment = true;
			}
			if (title == '患者编号') {
				column.title=<p>患者编号</p>
			} else {
				column.title = (<div style={{ display: "inline-block", whiteSpace: 'initial' }}>{title.split("\r\n").map((i, index) => {
					return <p>{i}</p>;
				})}</div>);
		    }
			if (dataIndex !== "op" && title != '录入者' && canAddComment != 1) {
                column.render = (text, record, index) => {
                    config.isEdit = true;
                    let isEdit = true;
                    if (record) {
                        if (record.editable == 0) {
                            isEdit = false;
                        } else {
                            const { typeName } = this.props;
                            if (typeName == 'Type_Pre_Filter' && (title == '预筛号' || title == '患者来源' || title == '其他来源描述' || title == '是否预筛成功')) {
                                isEdit = false;
                            } else if (typeName == 'Type_Filter' && (title == '筛选编号' || title == '是否筛选成功' || title == '知情同意时间' || title == '是否第一个受试者入组')) {
								isEdit = false;
							}
                        }
                    }
                    if (text) {
                        if (text.editable == 0) {
                            isEdit = false;
                        }
                    }
                    return (
                        !dataEmpty &&
                        <EditableCell
                            cellValue={text}
                            onChange={this.onCellChange(index, dataIndex, criteriaDefineId, false, record, tableColumn)}
                            onPatientCodeChange={this.onPatientCodeChange(index, dataIndex, criteriaDefineId, record)}
							typeName={typeName}
							config={config}
                            isEdit={isEdit}
                        />
                    )
                }

				columns.push(column);
			} else if (title == '录入者' && canAddComment != 1) {
				const { moduleDefineCode, moduleDefineId } = tableColumn;
				this.setState({
					moduleDefineCode,
					moduleDefineId
				})
				column.render = (text, record, index) => {
					return text ? <div className="editable-cell">{text.value}</div> : null;
				}
				columns.push(column);
			}
		});
		this.setState({ requiredMap });
		if (canEdit) {
			const opColumn = {
				title: '操作',
				dataIndex: 'operate',
				key: 'operate',
				fixed: 'right',
				width: 100,
				render: (text, record, index) => {
					if (record.children && record.children.length > 0) {
						return (<div className="editable-cell"> - </div>)
					} else {
						return (
							!dataEmpty &&
							<div className="editable-cell">
								{
									(curRole == 'CRC' || curRole == 'PM' || curRole == 'PA') &&
									(
										record.isSave ?
											<a onClick={() => this.props.canEditByInvStatus(() => this.rowSave(record, index))}>保存</a>
										:
											<a disabled={true}>保存</a>
									)
								}
								{
									(curRole == 'CRC' || curRole == 'PM') &&
									<span>
										<span className="ant-divider"></span>
										{
											record.deleteable == 1 ?
												<a onClick={() => this.props.canEditByInvStatus(() => this.showConfirm(record, index))}>删除</a>
											:
												<a disabled={true}>删除</a>
										}
									</span>
								}
							</div>
						);
					}
				},
			};
			columns.push(opColumn);
		}

		let visitTypeName = [];
		const parentColumn = [];
		columns.map((column) => {
			if (column.visitTypeName) {
				if (!visitTypeName.includes(column.visitTypeName)) {
					visitTypeName.push(column.visitTypeName);
				}
			}
		});
		visitTypeName.map((typeName) => {
			const typeColumn = {
				title: typeName,
			}
			const columnChildren = [];
			columns.map((column) => {
				if (column.visitTypeName == typeName) {
					columnChildren.push(column);
				}
			})
			typeColumn.children = columnChildren;
			parentColumn.push(typeColumn);
		})
		columns.map((column, colindex) => {
			if (visitTypeName.includes(column.visitTypeName)) {
				parentColumn.map((parcol, index) => {
					if (parcol.title == column.visitTypeName) {
						columns[colindex] = parentColumn[index];
						visitTypeName = visitTypeName.filter(value => value !== column.visitTypeName)
					}
				})
			} else {
				if (column.visitTypeName) {
					delete columns[colindex];
				}
			}
		});
		return { columns };
	}

	convertDataSource = dataSource => {
		const data = [];
		let key = 0;
		const { controllers, typeName, tableColumns } = this.props;
		dataSource.map(rowData => {
			const rowDataKey = Object.entries(rowData);
			let rowNum = 1;
			rowDataKey.map(rowKeyValue => {
				if (Array.isArray(rowKeyValue[1])) {
					const fieldArray = rowKeyValue[1];
					fieldArray.map((field => {
						rowNum = field.rowNum;
						const newKeyName = rowKeyValue[0] + "_" + field.rowNum;
						const newFieldValue = field;
						rowData[newKeyName] = { ...newFieldValue };
						// 填写控制
						if (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter') {
							const controll = controllers.find(controll => controll.controlled == rowKeyValue[0]);
							const controller = controll ? controll.controller : '';
							const controllValue = controll ? controll.value : '';
							const array = rowDataKey.find(rowData => rowData[0] == controller);
							const result = array ? array[1][rowNum - 1].value : '';
							rowData[newKeyName]['editable'] = (!controll || (controll && (result === controllValue) && array[1][rowNum - 1].editable != 0)) ? 1 : 0;
						}
					}));
				}
			});
			// 填写控制
			if (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter') {
				const columns = tableColumns.filter(item => !rowDataKey.find(rowKeyValue => rowKeyValue[0] == item.moduleDefineCode));
				columns.forEach(item => {
					const controll = controllers.find(controll => controll.controlled == item.moduleDefineCode);
					const controller = controll ? controll.controller : '';
					const controllValue = controll ? controll.value : '';
					const array = rowDataKey.find(rowData => rowData[0] == controller);
					const result = array ? array[1][rowNum - 1].value : '';
					rowData[item.moduleDefineCode + '_' + rowNum] = {
						rowNum,
						editable: (!controll || (controll && (result === controllValue) && array[1][rowNum - 1].editable != 0)) ? 1 : 0,
					};
				});
			}

			rowData["key"] = rowData.key;
			key++;
			rowData["isSave"] = false;
			let childRowNum = 1;
			if (rowData.children && rowData.children.length > 0) {
				rowData.children.map(value => {
					const rowChildKey = Object.entries(value);
					rowChildKey.map(childKeyValue => {
						if (Array.isArray(childKeyValue[1])) {
							const fieldArray = childKeyValue[1];
							fieldArray.map((field => {
								childRowNum = field.rowNum;
								const newKeyName = childKeyValue[0] + "_" + field.rowNum;
								const newFieldValue = field;
								value[newKeyName] = { ...newFieldValue };
								// 填写控制
								if (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter') {
									const controll = controllers.find(controll => controll.controlled == childKeyValue[0]);
									const controller = controll ? controll.controller : '';
									const controllValue = controll ? controll.value : '';
									const array = rowChildKey.find(rowChild => rowChild[0] == controller);
									const result = array ? array[1][childRowNum - 1].value : '';
									value[newKeyName]['editable'] = (!controll || (controll && (result === controllValue) && array[1][childRowNum - 1].editable != 0)) ? 1 : 0;
								}
							}));
						}
					});
					if (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter') {
						const columns = tableColumns.filter(item => !rowChildKey.find(childKeyValue => childKeyValue[0] == item.moduleDefineCode));
						// 填写控制
						columns.forEach(item => {
							const controll = controllers.find(controll => controll.controlled == item.moduleDefineCode);
							const controller = controll ? controll.controller : '';
							const controllValue = controll ? controll.value : '';
							const array = rowChildKey.find(rowChild => rowChild[0] == controller);
							const result = array ? array[1][childRowNum - 1].value : '';
							rowData[item.moduleDefineCode + '_' + childRowNum] = {
								rowNum: childRowNum,
								editable: (!controll || (controll && (result === controllValue) && array[1][childRowNum - 1].editable != 0)) ? 1 : 0,
							};
						});
					}
					value["key"] = value.key;
					key++;
					value["isSave"] = false;
				});
			}
			data.push(rowData);
		})
		this.setState({ count: key });
		return { data };
	}

	getFatherIndex = (record) => {
		const dataSource = this.state.dataSource;
		let dataIndex;
		dataSource.map((father, fatherIndex) => {
			if (father['children']) {
				father['children'].map((child, childIndex) => {
					if (child.key == record.key) {
						dataIndex = fatherIndex;
					}
				})
			}
		})
		return dataIndex;
	}

	onCellChange = (index, key, criteriaDefineId, special, record, tableColumn) => {
		return (value, type) => {
			const dataSource = [...this.state.dataSource];

			if (type == 'reRender') {
				this.setState({ dataSource });
				return;
			}

			const { controllers, tableColumns, typeName } = this.props;
			
			if ((record && record.child) !== 1 || record.child == undefined) {
				if (!dataSource[index][key] || (dataSource[index][key] && !dataSource[index][key]['moduleDefineCode'])) {
					this.initValue(dataSource[index], key, tableColumn);
					if (type !== "comment") {
						if (value !== "") {
							dataSource[index][key]['value'] = value;
						}
					}
				}
				this.loopController(typeName, dataSource[index], key, value, tableColumns, controllers);
				dataSource[index][key][type] = value;
				dataSource[index]["isSave"] = true;
			} else {
				const dataIndex = this.getFatherIndex(record);
				if (dataSource[dataIndex] && dataSource[dataIndex]['children']) {
					if (!dataSource[dataIndex]['children'][index][key] || (dataSource[dataIndex]['children'][index][key] && !dataSource[dataIndex]['children'][index][key]['moduleDefineCode'])) {
						this.initValue(dataSource[dataIndex]['children'][index], key, tableColumn);
						if (type !== "comment") {
							if (value !== "") {
								dataSource[dataIndex]['children'][index][key]['value'] = value;
							}
						}
					}
				}
				this.loopController(typeName, dataSource[dataIndex]['children'][index], key, value, tableColumns, controllers);
				dataSource[dataIndex]['children'][index][key][type] = value;
				dataSource[dataIndex]['children'][index]["isSave"] = true;
			}
			this.setState({ dataSource });
		};
	}

	initValue = (obj, code, tableColumn) => {
		const { typeName } = this.props;
		obj[code] = {
			comment: "",
			criteriaDefineId: tableColumn.criteriaDefineId,
			value: "",
			editable: 1,
			moduleDefineCode: tableColumn.moduleDefineCode,
			rowNum: tableColumn.rowNum,
		};
		if (typeName != 'Type_Visti') {
			obj[code]['realRowNum'] = obj['rowNum'];
		}
	}

	loopController = (typeName, obj, key, value, tableColumns, controllers) => {
		if (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter') {
			const suffix = key.slice(-2);
			const code = key.slice(0, key.length -2);
			// 查询是否是控制列表中
			controllers.forEach(item => {
				if (item.controller == code) {
					const controlledKey = item.controlled + suffix;
					if (item.oper == 'EQ') {
						//	被控制方存在
						if (obj[controlledKey] && obj[controlledKey].moduleDefineCode) {
							const editable = (item.value == value && obj[key]['editable'] != 0) ? 1 : 0;
							obj[controlledKey]['editable'] = editable;
							if (!editable) {
								obj[controlledKey]['value'] = '';
								if (typeName == 'Type_Filter') {
									if (item.controllerName == '随机(入组)时间' && item.controlledName == '患者编号') {
										const moduleDefine = tableColumns.find(column => column.moduleDefineName == '筛选编号') || {};
										const { moduleDefineCode } = moduleDefine;
										obj[controlledKey]['value'] = value ? obj[moduleDefineCode + suffix]['value'] : '';
									}
								}
							}
						} else {
							// 不存在
							const controllColumn = tableColumns.find(column => column.moduleDefineCode == item.controlled) || {};
							this.initValue(obj, controlledKey, controllColumn);
							const editable = (item.value == value && obj[key]['editable'] != 0) ? 1 : 0;
							obj[controlledKey]['editable'] = editable;
							if (!editable) {
								obj[controlledKey]['value'] = '';
								if (typeName == 'Type_Filter') {
									if (item.controllerName == '随机(入组)时间' && item.controlledName == '患者编号') {
										const moduleDefine = tableColumns.find(column => column.moduleDefineName == '筛选编号') || {};
										const { moduleDefineCode } = moduleDefine;
										obj[controlledKey]['value'] = value ? obj[moduleDefineCode + suffix]['value'] : '';
									}
								}
							}
						}
					}
					// 查询被控制方是否在控制列表中作为控制方存在
					const newValue = obj[controlledKey]['value'] || '';
					this.loopController(typeName, obj, controlledKey, newValue, tableColumns, controllers);
				}
			});
		}
	}

	onPatientCodeChange = (index, key, criteriaDefineId, record) => {
		return (value, type) => {
			const { dataSource } = this.state;
			if (record && record.child !== 1) {
				const rowObj = dataSource[index];
				if (rowObj.key && rowObj.key.endsWith("new5efk")) {
					dataSource[index].patientUserId = value.patientId;
				}
				dataSource[index].newPatientUserId = value.patientId;

			} else {
				const dataIndex = this.getFatherIndex(record);
				if (rowObj.key && rowObj.key.endsWith("new5efk")) {
					dataSource[dataIndex]['children'][index].patientUserId = value.patientId;
				}
				dataSource[dataIndex]['children'][index].newPatientUserId = dataSource[dataIndex]['children'][index].patientUserId;
			}
			this.setState({ dataSource });
		};
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ dataSource: [], columns: [], count: 0 }, () => {
			const { tableColumns, tableDatas, loading } = nextProps;
			this.setState({
				dataSource: this.convertDataSource(tableDatas).data,
				tableColumns,
				loading,
			}, () => {
				const { columns } = this.convertColumns(tableColumns);
				this.setState({ columns })
			});
		})
	}

	componentDidMount () {
		const { tableColumns, tableDatas, loading } = this.props;
		this.setState({
			dataSource: this.convertDataSource(tableDatas).data,
			tableColumns,
			loading,
		}, () => {
			const { columns } = this.convertColumns(tableColumns);
			this.setState({ columns })
		});
	}

	render() {
		const { dataSource, columns, loading } = this.state;
		return (
			<TableC
				columns={columns}
				loading={loading}
				pagination={false}
				scrollY={500}
				data={dataSource}
				rowKey="key"
				className='table-cell-row crf-table'
			/>
		);
	}
}

export default CrfTable;


// WEBPACK FOOTER //
// ./src/components/execute/crfHistory/CrfTable.js